import { Link } from "react-router-dom";
import { newsItems } from "@/mocks/news";

interface NewsCardProps {
  item: (typeof newsItems)[0];
  index: number;
  isVisible: boolean;
}

export default function NewsCard({ item, index, isVisible }: NewsCardProps) {
  return (
    <Link
      to={`/news/${item.slug}`}
      className={`group block bg-white rounded-xl border border-gray-200 overflow-hidden transition-all duration-700 hover:shadow-lg hover:border-gray-300 ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      }`}
      style={{ transitionDelay: `${index * 100}ms` }}
    >
      <div className="flex flex-col md:flex-row">
        <div className="bg-navy text-white px-6 py-4 md:px-8 md:py-6 md:w-48 shrink-0 flex flex-col md:flex-row items-center justify-center gap-2">
          <span className="text-gold font-bold text-sm tracking-wide">
            {item.date}
          </span>
          <span className="hidden md:block w-px h-4 bg-white/30" />
          <span className="text-xs text-white/70">{item.category}</span>
        </div>
        <div className="p-6 md:p-8 flex-1 flex items-center justify-between gap-4">
          <div className="flex-1 min-w-0">
            <h2 className="text-base md:text-lg font-bold text-navy mb-2 group-hover:text-gold transition-colors duration-300 line-clamp-2">
              {item.title}
            </h2>
            <p className="text-sm text-gray-500 leading-relaxed line-clamp-2">
              {item.excerpt}
            </p>
          </div>
          <div className="w-10 h-10 shrink-0 flex items-center justify-center rounded-full border border-gray-200 text-navy group-hover:bg-gold group-hover:border-gold group-hover:text-white transition-all duration-300">
            <i className="ri-arrow-right-s-line text-lg" />
          </div>
        </div>
      </div>
    </Link>
  );
}
